import React, { useState } from 'react'
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from '@mui/material'
import { useNotify, useRefresh } from 'react-admin'
import { client } from '../../providers/data/client'
import { kitStatusTagChoices } from '../fields/helpers/kitFieldsHelpers'

const StatusDetailModal = ({ open, handleClose, record, targetStatus }) => {
  const [statusDetail, setStatusDetail] = useState('normal')
  const notify = useNotify()
  const refresh = useRefresh()

  const handleConfirm = async () => {
    try {
      const response = await client().get(`/kits/${record.kitId}`)
      response.data.status = targetStatus

      const newTag = `${targetStatus}-${statusDetail}`
      const currentTags = response.data.statusTags || []

      // Append new tag if not already present
      if (!currentTags.includes(newTag)) {
        currentTags.push(newTag)
      }

      response.data.statusTags = currentTags
      // Remove legacy statusDetail if present to clean up
      if (response.data.statusDetail) delete response.data.statusDetail

      // Restangular update
      response.data.id = record.kitId.toString()
      await client().put(`/kits/${record.kitId}`, response.data)

      notify(`Kit status updated to ${targetStatus} (tag: ${newTag})`, { type: 'success' })
      refresh()
      handleClose()
    } catch (error) {
      console.error('Error updating kit status:', error,)
      let errorMessage = 'Error updating kit status'
      if (error?.response?.data?.message) {
        errorMessage = error.response.data.message
      } else if (error?.response?.data?.error) {
        errorMessage = error.response.data.error
      } else if (error?.message) {
        errorMessage = error.message
      }
      notify(errorMessage, { type: 'error', multiLine: true })
    }
  }

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Update Status to {targetStatus}</DialogTitle>
      <DialogContent>
        <Box sx={{ minWidth: 300, mt: 2 }}>
          <FormControl fullWidth>
            <InputLabel>Status Detail</InputLabel>
            <Select
              value={statusDetail}
              label="Status Detail"
              onChange={(e) => setStatusDetail(e.target.value)}
            >
              {kitStatusTagChoices.map((choice) => (
                <MenuItem key={choice.id} value={choice.id}>
                  {choice.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button onClick={handleConfirm} variant="contained" color="primary">
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default StatusDetailModal
